import React from "react";
import { ISectorEtrance } from "../../data/entities";
import styled from "styled-components";
import { IProjectSector } from "../../../project/data/entities";

const Item = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: white;
`;

const Text = styled.p`
  font-size: 0.95rem;
  font-weight: 700;
  margin: 0;
`;

const Seperator = styled.p`
  margin: 0 0.4rem;
  font-size: 0.95rem;
`;

const Number = styled.p`
  width: 24px;
  font-size: 0.95rem;
  font-weight: 700;
  margin: 0;
`;

interface IProps {
  etrance?: ISectorEtrance;
  data: IProjectSector;
}

export const EtranceInfo: React.FC<IProps> = ({ etrance, data }: IProps) => {
  return (
    !!etrance ?
      <div key={etrance?.name}>
        <Item className="my-2">
          <Text>1 otaqlı studio mənzil</Text>
          <Seperator>-</Seperator>
          <Number>{etrance?.studioCount}</Number>
        </Item>
        <Item className="my-2">
          <Text>1 otaqlı mənzil</Text>
          <Seperator>-</Seperator>
          <Number>{etrance?.oneRoomCount}</Number>
        </Item>
        <Item className="my-2">
          <Text>2 otaqlı mənzil</Text>
          <Seperator>-</Seperator>
          <Number>{etrance?.twoRoomCount}</Number>
        </Item>
        <Item className="my-2">
          <Text>3 otaqlı mənzil</Text>
          <Seperator>-</Seperator>
          <Number>{etrance?.threeRoomCount}</Number>
        </Item>
        <Item className="my-2">
          <Text>4 otaqlı mənzil</Text>
          <Seperator>-</Seperator>
          <Number>{etrance?.fourRoomCount}</Number>
        </Item>
        {etrance.fiveRoomCount > 0 && (
          <Item className="my-2">
            <Text>5 otaqlı mənzil</Text>
            <Seperator>-</Seperator>
            <Number>{etrance.fiveRoomCount}</Number>
          </Item>
        )}
      </div>
      :
      <>
        <div>
          <Item className="my-2">
            <Text>1 otaqlı studio mənzil</Text>
            <Seperator>-</Seperator>
            <Number>{data.studioCount}</Number>
          </Item>
          <Item className="my-2">
            <Text>1 otaqlı mənzil</Text>
            <Seperator>-</Seperator>
            <Number>{data.oneRoomCount}</Number>
          </Item>
          <Item className="my-2">
            <Text>2 otaqlı mənzil</Text>
            <Seperator>-</Seperator>
            <Number>{data.twoRoomCount}</Number>
          </Item>
          <Item className="my-2">
            <Text>3 otaqlı mənzil</Text>
            <Seperator>-</Seperator>
            <Number>{data.threeRoomCount}</Number>
          </Item>
          <Item className="my-2">
            <Text>4 otaqlı mənzil</Text>
            <Seperator>-</Seperator>
            <Number>{data.fourRoomCount}</Number>
          </Item>
          {data.fiveRoomCount > 0 && (
            <Item className="my-2">
              <Text>5 otaqlı mənzil</Text>
              <Seperator>-</Seperator>
              <Number>{data.fiveRoomCount}</Number>
            </Item>
          )}
        </div>
      </>
  );
};